// extracted by mini-css-extract-plugin
export default {"wrapper":"Alarms_wrapper__iDMUm","empty":"Alarms_empty__aH3Ba","row":"Alarms_row__5khNx","icon":"Alarms_icon__DLIgM"};